<template>
  <div>
    <div class="customer1"></div>
    <div class="record2">
      <el-form ref="added" inline size="medium">
        <el-form-item label="服务对象名称">
          <el-input v-model="query.name_or_phone" placeholder="请输入服务对象名称或手机号" clearable @keyup.enter.native="search">
          </el-input>
        </el-form-item>
        <el-form-item label="社工名称">
          <el-input v-model="query.founders" placeholder="社工名称或手机号" clearable @keyup.enter.native="search">
          </el-input>
        </el-form-item>
        <el-form-item label="重要程度">
          <el-select v-model="query.important_degree" placeholder="请选择" clearable style="width: 120px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="普通" :value="0"></el-option>
            <el-option label="一般" :value="1"></el-option>
            <el-option label="重要" :value="2"></el-option>
            <el-option label="非常重要" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="query.audit_status" placeholder="请选择" clearable style="width: 120px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="未审核" :value="0"></el-option>
            <el-option label="预审核" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <div></div>
        <el-form-item label="服务时间">
          <!-- <el-select v-model="query.service_add_date" placeholder="请选择" style="width: 120px;">
            <el-option :label="date" :value="date" v-for="date in DateList" :key="date"></el-option>
          </el-select> -->
          <el-date-picker class="my-date" style="width: 120px;" v-model="query.service_add_date" type="month" value-format="yyyy-MM"
            :clearable='false' :defaultValue='defaultValue' placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="区域">
          <el-cascader v-model="query.code" ref='area' :options="areaList" clearable popper-class='myArea' :props="{
            expandTrigger: 'hover',
            children: 'child',
            label:'area_name',
            value:'area_code',
            checkStrictly: true
          }" @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'customerLog/query')">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'customerLog/query')">
          <el-button type="info" icon="el-icon-refresh-right" @click="reset"> 重置 </el-button>
        </el-form-item>
        <!-- <div></div>
        <span style="padding-left: 70px;"></span>
        <el-form-item v-if="JudgeButton(role_permission,'customerLog/download')">
          <el-button type='info' icon="el-icon-download" @click="dwonload">模板下载</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload v-if="JudgeButton(role_permission,'customerLog/inport')" :auto-upload="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" action
            :show-file-list='false' :on-change="handleChansge">
            <el-button type="success" icon="el-icon-circle-plus-outline">导入服务对象</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item v-if="JudgeButton(role_permission,'customerLog/export')">
          <el-button :disabled="!list.length" type="warning" icon="el-icon-upload2" @click="handleExport">导出服务对象
          </el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'customerLog/allocation')">
          <el-button :disabled="!multipleSelection.length" type="danger" icon="el-icon-connection"
            @click="handleDistribute">批量分配</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="customer3">
      <el-table v-loading='loading' stripe border ref="multipleTable" :data="list" tooltip-effect="dark"
        style="width: 98%">
        <!-- <el-table-column :selectable="checkSelectMember" align='center' type="selection" width="55"></el-table-column> -->

        <el-table-column align='center' prop='customer_name' label="服务对象姓名" width="120">
          <template slot-scope="scope">
            <span style="color: #2F91FE;cursor: pointer;"
              @click="detailsReset(scope.$index, scope.row)">{{ scope.row.customer_name || '--' }}</span>
          </template>
        </el-table-column>

        <el-table-column align='center' prop="name" label="性别" width="80">
          <template slot-scope="scope">
            {{ scope.row.customer_sex | isSex }}
          </template>
        </el-table-column>
        <el-table-column align='center' prop="customer_age" label="年龄" width="80">
        </el-table-column>
        <el-table-column align='center' label="重要程度" width="130">
          <template slot-scope="scope">
            <span
              :class="'state-'+scope.row.customer_important_degree">{{ scope.row.customer_important_degree | isImportant }}</span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="customer_phone" label="手机号" width='150px'>
        </el-table-column>

        <el-table-column align='center' prop="customer_area_name" label="居住区域" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column align='center'
                  prop="customer_current_address"
                  label="现住地址"
                  show-overflow-tooltip
                 >
                </el-table-column> -->
        <el-table-column align='center' prop="address2" label="当月服务情况" width="230">
          <template slot-scope="scope">
            线上（<span style="color: #2F91FE;">{{ scope.row.current_month_service_total_online || 0 }}</span>）
            线下（<span style="color: #2F91FE;">{{ scope.row.current_month_service_total_offline || 0 }}</span>）
          </template>
        </el-table-column>
        <el-table-column align='center' label="服务时间" width="150">
          <template>
            {{ query.service_add_date }}
          </template>
        </el-table-column>
        <el-table-column align='center' label="当月服务状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.current_month_service_audit_status == 0" style="color: #999999;">未审核</span>
            <span v-if="scope.row.current_month_service_audit_status == 1" style="color: #7FC418;">合格</span>
            <span v-if="scope.row.current_month_service_audit_status == 2" style="color: #E65D6E;">不合格</span>
            <span v-if="scope.row.current_month_service_audit_status == 3" style="color: #DF384C;">终审不合格</span>
            <span v-if="scope.row.current_month_service_audit_status == 4" style="color: #7FC418;">预审合格</span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="founders" label="服务社工" width="110">
        </el-table-column>
        <el-table-column label="操作" align='center' width='200px'>
          <template slot-scope="scope">
            <!-- <el-button
						size="mini"
						type="primary"
						@click="hanReset(scope.$index, scope.row)">服务记录</el-button> -->
            <el-button v-if="JudgeButton(role_permission,'customerLog/details')" size="mini" type="primary"
              @click="detailsReset(scope.$index, scope.row)">处理</el-button>
            <!-- <el-button v-if="JudgeButton(role_permission,'customerLog/delete')"
						size="mini"
						type="danger"
						@click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>


    <el-dialog title="批量分配" :visible.sync="dialogVisible" width="33%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" style="min-height: 300px;">
        <el-form-item label="服务对象姓名:" style="margin-bottom: 0px;">
          <span class="cu" v-for="(item,i) in multipleSelection" :key="i">{{ item.customer_name }}</span>
        </el-form-item>
        <el-form-item label="请选择社工:" prop="user_id">
          <el-radio-group v-model="ruleForm.user_id">
            <el-radio style="margin-top: 15px;" :label="item.user_id" v-for="(item, index) in userList" :key="index">
              {{ item.user_name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="handleComfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  var that;
  const year = new Date().getFullYear();
  const month = new Date().getMonth() + 1 < 10 ?
    "0" + (new Date().getMonth() + 1) :
    new Date().getMonth() + 1;
  export default {
    name: 'customerLogManage',
    data() {
      return {
        loading: true,
        list: [],
        important: ['普通', '一般', '重要', '非常重要'],
        areaList: [],
        query: {
          name_or_phone: '',
          important_degree: '',
          founders: '',
          area_code: '',
          village_code: '', // 村code
          page_limit: 10,
          page: 1,
          flag: '', // 操作标志 export=数据导出
          total: 0,
          service_add_date: '',
          audit_status: '',
          code: ''
        },
        multipleSelection: [],
        dialogVisible: false,

        userList: [],
        userPage: 1,
        ruleForm: {
          user_id: ''
        },
        rules: {
          user_id: [{
            required: true,
            message: '请选择社工',
            trigger: 'change'
          }],
        },
        DateList: [],
        defaultValue: year + '-' + month
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    beforeDestroy() {
      this.$store.commit('CACHE_CUSTOMERLOG', this.query)
    },
    created() {
      that = this;
      if (this.$store.state.cache.cacheCustomerLogQuery) this.query = this.$store.state.cache.cacheCustomerLogQuery
      this.query.flag = ''
      this.query.service_add_date = this.defaultValue
      this.getList()
      // this.getDateList()
    },
    methods: {
      getDateList() {
        userInfoAPI.getDateList().then((res) => {
          if (res.data.code == 0) {
            this.DateList = res.data.data || []
            this.query.service_add_date = res.data.data[0]
          }
          this.getList()
        })
      },
      search() {
        this.loading = true;
        this.query.flag = '';
        this.query.page = 1;
        this.list = [];
        this.getList()
      },
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      checkSelectMember(row, index) {
        // return row.founders === false || row.founders === ''
        return true
      },
      handleSelectionChange(val) { //是否全选框框
        this.multipleSelection = val;
      },
      handleChansge(file, fileList) {
        let formData = new FormData();
        formData.append('import_file', file.raw)
        userInfoAPI.customerImport(formData).then(({
          data
        }) => {
          if (data.code == 0) {
            this.getList()
            this.$message({
              type: 'success',
              message: '服务对象导入成功!'
            });
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            })
          }
        })
      },
      dwonload() {
        userInfoAPI.systemFileDownload({
          flag: 'customer_import_dome'
        }).then(({
          data
        }) => {
          if (data) {
            let blob = new Blob([data], {
              type: 'application/vnd.ms-excel'
            })
            let objectUrl = URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.href = objectUrl
            link.setAttribute('download', '服务对象导入模板')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(objectUrl)
            this.$message({
              type: 'success',
              message: '下载成功!'
            });
          }
        }).catch(() => {
          this.loading = false
        })
      },
      handleExport() {
        this.query.flag = 'export';
        this.getList();
      },
      getUserList() {
        userInfoAPI.serviceUserList({
          page_limit: 99,
          page: this.userPage,
        }).then(res => {
          if (res.data.code == 0) {
            this.userList = this.userList.concat(res.data.data.list || [])
            if (res.data.data.list.length == 99) {
              this.userPage++
              this.getUserList()
            }
          }
        })
      },
      handleDistribute() {
        this.ruleForm.user_id = ''
        this.userPage = 1
        this.userList = []
        this.getUserList()
        this.dialogVisible = true
      },
      handleChange(e) {
        if (e[0]) {
          this.query.area_code = e[0]
          this.query.village_code = e[1] || ''
          if (e[1]) {
            that.$refs.area.dropDownVisible = false
          }
        } else {
          this.query.area_code = ''
          this.query.village_code = ''
        }
      },
      handleComfirm() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            userInfoAPI.customerAllocation({
              user_id: this.ruleForm.user_id,
              customer_id: this.multipleSelection.map(i => {
                return i.customer_id
              }).join(',')
            }).then(({
              data
            }) => {
              if (data.code == 0) {
                this.getList()
                this.dialogVisible = false
                this.$message({
                  type: 'success',
                  message: '分配成功!'
                });
              } else {
                this.$message({
                  showClose: true,
                  message: data.msg,
                  type: 'error'
                })
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      reset() {
        this.query.name_or_phone = ''
        this.query.founders = ''
        this.query.important_degree = ''
        this.query.area_code = ''
        this.query.village_code = ''
        this.query.code = ''
      },
      handleDelete(index, row) { //删除
        if (row.is_service_ing == 1) {
          this.$message({
            type: 'error',
            message: '该人员正在服务中，禁止删除操作！'
          })
          return
        }
        this.$confirm('是否确定删除该服务对象, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceCustomerDel({
            customer_id: row.customer_id
          }).then(({
            data
          }) => {
            if (data.code == 0) {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error'
              })
            }
          })
        })
      },
      detailsReset(index, row) { //详情
        this.$router.push({
          path: 'detailLog',
          query: {
            customer_id: row.cid,
            date: this.query.service_add_date
          }
        })
      },
      getList() {
        this.loading = true
        userInfoAPI.customerService(this.query).then(res => {
          if (this.query.flag == 'export') {
            let blob = new Blob([res.data], {
              type: 'application/vnd.ms-excel'
            })
            let objectUrl = URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.href = objectUrl
            link.setAttribute('download', '服务对象人员名单')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(objectUrl)
          } else {
            if (res.data.code == 0) {
              this.list = res.data.data.list || []
              this.query.total = res.data.data.page.count || 0
            }
          }
          this.getAreaList()
          this.loading = false
        })
      },
      getAreaList() {
        userInfoAPI.systemSelectionList().then(({
          data
        }) => {
          if (data.code == 0) {
            this.areaList = data.data;
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            })
          }
        })
      },
      handleSizeChange(val) {
        this.query.flag = '';
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.flag = '';
        this.query.page = val;
        this.getList();
      }
    }
  }
</script>
<style lang='scss' scoped>
  ::v-deep{
    .my-date.el-input--suffix .el-input__inner{
      padding-right: 0;
    }
  }
  .customer1 {
    height: 20px;
  }

  .state-2 {
    color: #e4be44;
  }

  .state-3 {
    color: red;
  }

  .customer3 {
    margin-left: 20px;
  }

  .cu {
    &::after {
      content: '、';
    }

    &:nth-last-child(1)::after {
      content: '';
    }
  }

  .record2 .el-form-item {
    margin-left: 20px;
  }
</style>
